import axios from 'axios'
import { i18n } from '../../plugins/i18n'
import { allSitesConst } from '../../modules/sitesConst'

function combinedStoreSite(siteStores) {
  return allSitesConst.map((site) => {
    const matchedSite = siteStores.find((d) => d.attributes.site_type === site.siteType)
    return {
      ...site,
      url: matchedSite ? matchedSite.attributes.url : ''
    }
  })
}

export const companiesSites = {
  namespaced: true,
  state: {
    data: null,
    // 表示切り替え時にロードした状態に戻すのに使う
    storeSites: null,
    loading: false,
  },
  mutations: {
    readSites(state) {
      state.data = null
      state.loading = true
    },
    apiSuccess(state, payload) {
      state.storeSites = payload.data
      state.data = combinedStoreSite(state.storeSites)
      state.loading = false
    },
    resetSites(state) {
      state.data = combinedStoreSite(state.storeSites)
    },
    apiFailure(state) {
      state.loading = false
    },
    updateSites(state) {
      state.loading = true
      state.errors = null
    },
  },
  actions: {
    readSites({ commit }, { company_uuid, store_uuid }) {
      commit('readSites')

      return axios
        .get('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/sites.json')
        .then(res => {
          commit('apiSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
    updateSites({ commit, state }, {company_uuid, store_uuid, sites}) {
      if (state.loading) return

      commit('flash/clearFlash', null, { root: true })
      commit('updateSites')
      const data = sites.map(site => {
        return {
          site_type: site.siteType,
          url: site.url
        }
      })

      const payload = { sites: data }
      return axios
        .put('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/sites.json', payload)
        .then((res) => {
          commit('apiSuccess', res.data)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updatedInfo', { value: i18n.t('models.siteStore.modelName') }) }, { root: true })
        })
        .catch(err => {
          console.error(err)
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    resetSites({ commit }) {
      commit('resetSites')
    }
  }
}
